/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getCsvDiscountCouponModel, uploadCsvDiscountCoupon } from '../app/store/actions/discountCoupon';
import ModalComponent from '../components/modal';
import UploadFilesComponent from '../components/upload';
import ImportErrors from '../components/upload/ImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';


class UploadClientsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      showModal: false,
      titleModal: '',
      titleModalBody: '',
      importMessage: null,
    };
  }

  sendFile = async (file) => {
    await this.setState({
      errors: {},
      importMessage: null,
    });

    try {
      const result = await this.props.uploadCsvDiscountCoupon(file);
      await this.setState({
        errors: (result && result.errors) || [],
        importMessage: (result && result.createdCoupons)
          ? I18n.t('successfulImportMessage', { 0: result.createdCoupons })
          : null,
      });
      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  modelDownload = async () => {
    try {
      await this.props.getCsvDiscountCouponModel();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => {
    history.push(ROUTES.DISCOUNT_COUPON);
  }

  render() {
    const {
      errors, showModal, titleModal, titleModalBody, importMessage,
    } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">

          <h2>{I18n.t('importDiscountCoupons')}</h2>

          <div className="upload-text">
            <p><strong>{I18n.t('importText1')}</strong></p>
            <p>{I18n.t('importText2')}</p>
            <p>{I18n.t('importText3')}</p>
            <p>{`${I18n.t('importCouponsText1')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{I18n.t('importCouponsText2')}</p>
            <p>{`${I18n.t('importCouponsText3')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importCouponsText11')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{I18n.t('importCouponsText4')}</p>
            <p>{`${I18n.t('importCouponsText5')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importCouponsText6')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{I18n.t('importCouponsText7')}</p>
            <p>{`${I18n.t('importCouponsText8')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importCouponsText9')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importCouponsText10')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            importMessage={importMessage}
            itemsErrors={(
              <ImportErrors
                title={I18n.t('couponsNotAdded')}
                errorMessage="couponsNotAdded"
                errors={errors}
              />
            )}
          />

          <ModalComponent
            title={titleModal}
            body={titleModalBody}
            visible={showModal}
            closeModal={() => this.setState({ showModal: false })}
            titleOkButtoon={I18n.t('ok')}
            size={{ width: '350px', height: '200px' }}
            showButtons
            confirmModal={() => this.setState({ showModal: false })}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadCsvDiscountCoupon: file => dispatch(uploadCsvDiscountCoupon(file)),
  getCsvDiscountCouponModel: () => dispatch(getCsvDiscountCouponModel()),
});

export default connect(null, mapDispatchToProps)(UploadClientsPage);
